import storageHelper from './storage'
import i18n from 'i18next'
import { authBroadcast } from '../services/AuthBroadcast'

const interceptorsHelper = {
    addInterceptors: (axiosInstance) => {
        axiosInstance.interceptors.request.use(
            (config) => {
                // Ensure headers object exists
                config.headers = config.headers || {}

                // storageHelper.getToken() ya maneja JSON.parse internamente
                const token = storageHelper.getToken()

                if (token) {
                    // Header principal unificado
                    config.headers['Authorization'] = `Bearer ${token}`
                    // Legacy: mantener por compatibilidad con egg-api
                    config.headers['access-token'] = token
                } else {
                    // Remove any possibly stale headers for this request
                    try {
                        delete config.headers['Authorization']
                        delete config.headers['access-token']
                    } catch (e) {
                        // ignore
                    }
                }

                const lng = i18n.language
                if (lng) {
                    config.headers['accept-language'] = `${lng}_${lng.toUpperCase()}`
                }

                return config
            },
            (error) => Promise.reject(error)
        )

        axiosInstance.interceptors.response.use(
            (response) => ({
                status: response?.status,
                data: response.data.data || response.data,
                message: response.data.message,
            }),
            (error) => {
                if (error.response?.status === 401) {
                    // NO hacer firebase.auth().signOut() - afectaría todas las pestañas
                    // Obtener token antes de limpiar session para poder notificar a otras pestañas
                    const currentToken = storageHelper.getToken()
                    try {
                        // Mark intentional logout BEFORE clearing token to avoid recovery races
                        storageHelper.setHasLoggedOut(true)
                    } catch (e) {
                        // ignore
                    }
                    // Solo limpiar sesión de esta pestaña y redirigir
                    storageHelper.clearSession()
                    try {
                        if (currentToken) {
                            authBroadcast.broadcastLogout(currentToken)
                        }
                    } catch (e) {
                        // ignore
                    }
                    window.location.replace('/login')
                }
                return Promise.reject({
                    status: error.response?.status,
                    data: error.response?.data,
                })
            }
        )
    },
}

export default interceptorsHelper
